export function getConfigurationFilterId(cid: number) {
  return `${cid}-filter`;
}
